import { FC } from 'react'

export type LeaseTabKey = 'activos' | 'terminados' | 'rechazados'

interface LeaseTabsProps {
  active: LeaseTabKey
  onChange: (tab: LeaseTabKey) => void
}

const TABS: { key: LeaseTabKey; label: string }[] = [
  { key: 'activos', label: 'ACTIVOS' },
  { key: 'terminados', label: 'TERMINADOS' },
  { key: 'rechazados', label: 'RECHAZADOS' },
]

// Copia liviana de ProposalTabs.tsx (mismas clases) con las llaves propias
// de "Mis arrendamientos" — se duplica en vez de generalizar para no tocar
// el tab de cotizaciones ya funcionando.
export const LeaseTabs: FC<LeaseTabsProps> = ({ active, onChange }) => {
  return (
    <div className="flex border-b border-olr-grey-2 mb-6">
      {TABS.map(tab => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={`flex-1 px-4 py-3 text-xs font-semibold tracking-wide text-center border-b-2 transition-colors ${
            active === tab.key
              ? 'border-olr-primary text-olr-primary'
              : 'border-transparent text-olr-body hover:text-olr-dark'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
